import Auth from "@capable-health/capable-auth-sdk";
import { useState } from "react";
import { formatError } from "utils/strings";

export const useResetPassword = (onSuccess: () => void) => {
  const [isError, setIsError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const resetPassword = async (email: string, password: string, code: string) => {
    try {
      setIsError(undefined);
      setIsLoading(true);
      await Auth.credentials.completeForgotPassword(email, password, code);
      onSuccess();
    } catch (error) {
      console.error(error);
      setIsError(formatError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return { resetPassword, isError, isLoading };
};
